import { UseCTAStepFunc } from '../types.d'
import { OnboardingStepKey } from '@cbgms/api'
import { AcceptHaynesProEULACTA } from './AcceptHaynesProEULACTA'
import { useStepData } from '../use-step-data'

export const useAcceptHaynesProEULAStep: UseCTAStepFunc<{}, {}> = ({ onboardingInfo }) => {
  const stepName = OnboardingStepKey.HaynesProEULA
  const stepData = useStepData(stepName, onboardingInfo)

  return {
    Component: null,
    CTAComponent: AcceptHaynesProEULACTA,
    step: stepName,
    stepData,
    shouldExecuteStep: false,
    stepProps: { duplicationCheck: stepData.DuplicationCheck || [] }
  }
}
